import notificationError from '@/utils/functions/notificationError';
import { useInfiniteQuery, useMutation } from 'react-query';
import { RecipientInvoiceQueryFilter } from './recipientInvoice.types';
import { listRecipientInvoice, maximumNsu } from './recipientInvoice.services';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import { message } from 'antd';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';

export function useRecipientInvoiceList(params?: RecipientInvoiceQueryFilter) {
  return useInfiniteQuery(
    ['recipient-invoice-list', { ...params }],
    ({ pageParam: nextToken }) => {
      const req: RecipientInvoiceQueryFilter = {
        nextToken,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return listRecipientInvoice(req);
    },
    {
      enabled: !!params?.companyId,
      getNextPageParam: (lastPage) => lastPage.nextToken,
      onSuccess(data) {
        const recipientInvoiceList = flatInfiniteData(data);

        if (!recipientInvoiceList?.length) {
          message.info('Sem dados!');
        }
      },
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useMaximumNsu() {
  return useMutation(maximumNsu, {
    onError(error) {
      notificationError(error);
    },
  });
}
